module.exports = __webpack_public_path__ + "img/logo.7bfb94b9.png";